<template>
  <div>
    <MsButton :button-custom-style="buttonClassStyle" :button-font="buttonFontStyle">
      <template v-if="isActive">
        <img :src="live" class="icon" />
      </template>
      LIVE
    </MsButton>
  </div>
</template>

<script setup lang="ts">
import { defineProps, computed } from 'vue'
import live from '@/assets/svg/live.svg'
import MsButton from '@/components/general/buttons/MsButton.vue'

const props = defineProps({
  isActive: Boolean
})

const buttonClassStyle = computed(() => `btn-filter ${props.isActive ? 'active' : ''}`)

const buttonFontStyle = computed(() => `${props.isActive ? 'NKT-P2-medium' : 'NKT-P2'}`)
</script>
